// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
/* eslint-disable @typescript-eslint/no-unused-vars */
import { IsNotEmpty } from 'class-validator';

/* eslint-enable @typescript-eslint/no-unused-vars */ //JTH
export interface ISsoCompleteSignup {
	organizationName: string;

	organizationAddress: string | undefined;

	organizationAddress2: string | undefined;

	organizationCity: string | undefined;

	organizationState: string | undefined;

	organizationZipcode: string | undefined;

	organizationPhoneNumber: string | undefined;

	$type?: string | undefined;
}
export class SsoCompleteSignup {
	constructor(data?: ISsoCompleteSignup) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
	}

	@IsNotEmpty()
	organizationName: string = "";

	organizationAddress: string | undefined;

	organizationAddress2: string | undefined;

	organizationCity: string | undefined;

	organizationState: string | undefined;

	organizationZipcode: string | undefined;

	organizationPhoneNumber: string | undefined;

	static $type: string = "CoreApi.Models.View.SsoCompleteSignup, ";
	$type?: string | undefined = SsoCompleteSignup.$type;
}

